import React, { useState } from "react";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { api, errorMessage } from "../lib/api";

export default function ContactPage() {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) return;
    setSubmitting(true);
    try {
      await api.post("/messages", { name, message });
      toast.success("Message sent — we'll respond soon!");
      setName(""); setMessage("");
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setSubmitting(false); }
  };

  return (
    <Layout>
      <section className="page-section" data-testid="contact-page">
        <div className="max-w-xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <p className="text-sm uppercase tracking-[0.25em] font-bold text-white/85 drop-shadow">Get In Touch</p>
            <h1 className="font-display font-extrabold text-4xl md:text-6xl mt-2 text-white drop-shadow-lg">Contact Us</h1>
            <p className="text-white/90 mt-3">Questions, feedback, or just want to say hi? We'd love to hear from you.</p>
          </div>

          <form onSubmit={submit} className="card-soft p-6 md:p-8 space-y-4" data-testid="contact-form">
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Your Name</span>
              <input className="input-base mt-1" value={name} onChange={e => setName(e.target.value)} required data-testid="contact-name" />
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Message</span>
              <textarea className="input-base mt-1 min-h-[160px]" value={message} onChange={e => setMessage(e.target.value)} required data-testid="contact-message" />
            </label>
            <button type="submit" disabled={submitting} className="btn-pink w-full" data-testid="contact-submit-btn">
              {submitting ? "SENDING..." : "SEND MESSAGE"}
            </button>
          </form>
        </div>
      </section>
    </Layout>
  );
}
